import { useGetCanaryRolloutStatus } from 'src/hooks';

import { CanaryBanner } from './CanaryBanner';

export const CanaryBannerContainer = () => {
  const { data } = useGetCanaryRolloutStatus();

  return <CanaryBanner visible={data?.canaryWindowOpen ?? false} />;
};
